<template>
  <div>
    <div class="">
      <form>
        <div class="form-group">
          <label for="" class="">*目前密碼</label>
          <input type="password" class="form-control" placeholder="" v-model="formData.pwdCurrent">
        </div>
        <div class="form-group">
          <label for="" class="">*新密碼</label>
          <input type="password" class="form-control" placeholder="" v-model="formData.pwdNew">
        </div>
        <div class="form-group">
          <label for="" class="">*新密碼(確認)</label>
          <input type="password" class="form-control" placeholder="" v-model="formData.pwdNewConfirm">
        </div>
        <div class="form-group">
          <button type="button" class="btn btn-primary" @click="changePwd()">確定</button>
        </div>
      </form>
    </div>

  </div>
</template>

<script>/**

 **/
import apiAdmin from "@/views/taylorAdmin/js/apiAdmin";


export default {
  data: function () {
    return {
      id: "",
      formData: {
        pwdCurrent: "",
        pwdNew: "",
        pwdNewConfirm: "",
      },
    };
  },
  methods: {
    changePwd() {
      debugger // eslint-disable-line
      if (this.formData.pwdNew !== this.formData.pwdNewConfirm) {
        alert("新密碼與確認密碼不相同");
        return;
      }

      apiAdmin.api_Admin_ChangePwd(this.formData.pwdCurrent,this.formData.pwdNew).then((data)=>{
        if (data.data.status==="success") {
          alert("密碼修改成功");
        } else {
          alert(data.data.msg);
        }
      })

    },
  },
  mounted() {
    // this.initValue()
    //this.loadData()
  },
}
</script>

<style scoped>
input{
  max-width:300px;
}
</style>
